import { notification } from "antd";
import { createContext, useContext } from "react";

const NotifyContext = createContext(null);

export const NotifyProvider = ({ children }) => {
  const [api, contextHolder] = notification.useNotification({
    placement: "topLeft",
    top: 160
  });

  const notify = {
    success: (message, description = "") =>
      api.success({
        message,
        description,
      }),

    error: (message, description = "") =>
      api.error({
        message,
        description,
      }),

    warning: (message, description = "") =>
      api.warning({
        message,
        description,
      }),

    info: (message, description = "") =>
      api.info({
        message,
        description,
      }),
  };

  return (
    <NotifyContext.Provider value={notify}>
      {contextHolder}
      {children}
    </NotifyContext.Provider>
  );
};

export const notify = {};

export const NotifyInitializer = () => {
  const ctx = useContext(NotifyContext);
  Object.assign(notify, ctx);
  return null;
};
